import PropTypes from 'prop-types';
import React from 'react';

import styles from './index.scss';

const Badge = ({ children, className, count = 0, style }) => (
  <div className={className}>
    {children}
    {count > 0 && (
      <div
        className={styles.badge}
        style={{ top: '10%', right: '30%', ...style }}
      >
        {count > 9 ? '9+' : count}
      </div>
    )}
  </div>
);

Badge.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  count: PropTypes.number,
  style: PropTypes.object,
};

export default Badge;
